import {Component, inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {JobsService} from "../../../services/jobs.service";
import {AttachmentType} from "../../../enums/attachment-type";

@Component({
  selector: 'app-job-attachments-details',
  templateUrl: './job-attachments-details.component.html',
  standalone: false
})
export class JobAttachmentsDetailsComponent implements OnInit {
  paginatedImages: any[] = [];
  totalItems: number = 0;
  jobId: any;
  jobNumber: any;
  attachmentTypeId: any;
  attachmentTypeName: any;
  page: number = 1;
  readonly itemsPerPage: number = 10;
  totalPages: number = 1;
  showLoading: boolean = false;
  offset: number = 0;
  search: string = "";
  isLoading: boolean = false;

  protected readonly Math = Math;
  protected readonly String = String;
  protected readonly AttachmentType = AttachmentType;
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly jobService = inject(JobsService);

  async ngOnInit() {
    this.jobId = this.route.snapshot.queryParams['job_id'];
    this.search = this.route.snapshot.queryParams['search'] || "";
    this.attachmentTypeId = this.route.snapshot.queryParams['attachment_type_id'];
    this.attachmentTypeName = this.getAttachmentTypeName(this.attachmentTypeId);
    this.getJobDetails();
    this.getJobAttachmentsWithPagination(this.jobId, this.attachmentTypeId, this.search, 10, 0);
  }

  getJobAttachmentsWithPagination(job_id: string, attachment_type_id: string, search: string, limit: number, offset: number) {
    this.isLoading = true;
    this.paginatedImages = [];
    this.totalItems = 0;
    this.totalPages = 0;
    this.jobService.getJobAttachmentsWithPagination(job_id, attachment_type_id, search, limit, offset).then((data: any) => {
      if (!data) {
        return [];
      }
      if (data.Data || data.Data.length > 0) {
        this.totalItems = data.Data[0].total_count;
        this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
        this.paginatedImages = data.Data;
        return data.Data;
      }
    }).catch(() => {
      return [];
    }).finally(() => {
      this.isLoading = false;
    });
  }

  getJobDetails() {
    this.jobService.getJobById(this.jobId).then((res: any) => {
      if (res && res.Data && res.Data.JobId) {
        this.jobNumber = res.Data.JobNumber;
      }
    });
  }

  async filterSearchChanged(): Promise<void> {
    this.page = 1;
    this.offset = 0;
    this.getJobAttachmentsWithPagination(this.jobId, this.attachmentTypeId, this.search, this.itemsPerPage, this.offset);
  }

  nextPage() {
    if (this.page < this.totalPages) {
      this.page++;
      this.offset = this.offset + 10;
      this.getJobAttachmentsWithPagination(this.jobId, this.attachmentTypeId, this.search, this.itemsPerPage, this.offset);
    }
  }

  prevPage() {
    if (this.page > 1) {
      this.page--;
      this.offset = this.offset - 10;
      this.getJobAttachmentsWithPagination(this.jobId, this.attachmentTypeId, this.search, this.itemsPerPage, this.offset);
    }
  }

  getAttachmentTypeName(attachment_type_id: any): string {
    switch (attachment_type_id) {
      case '1':
        return 'Job Paperwork';
      case '2':
        return 'Incoming Asset Photos';
      case '3':
        return 'Outgoing Asset Photos';
      case '4':
        return 'Customer Info';
      default:
        return 'Unknown Attachment';
    }
  }

  goToJobPage() {
    this.router.navigate(['/job'], {queryParams: {job_id: this.jobId}}).toString();
  }
}
